import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Margenes {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/margenes/create`,
            form,
            headers: headers
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/margenes/update`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(form, page = 0) {
        const response = await Api.post({
            url: `${Backend}/margenes/list/${page}`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/margenes/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getByParam(form) {
        const response = await Api.post({
            url: `${Backend}/margenes/getByParam`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
